import React from 'react';
import { Icons } from '../../components/atoms/SVG';
import { WidgetType } from '../../types/api/ElementType';
import { ContextWidget } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ExternalLinksBlock } from '../../_blocks/ExternalLinks/ExternalLinksBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { FetchType } from '../../types/api/FetchType';
import { isEmptyBlock } from '../../types/api/Block';

export type ExternalLinksWidget = ContextWidget<ExternalLinksBlock, WidgetType.externallinks>;
function getWidgetTitle(block: ExternalLinksWidget['blocks'][0]) {
  if (block.fetchType === FetchType.lazy) {
    return null;
  }
  if (isEmptyBlock(block)) {
    return null;
  }
  return block.embedded.widgetTitle;
}

export function ExternalLinksWidget({ blocks, ...props }: ExternalLinksWidget) {
  const { t } = useSonTranslation('ExternalLinks');

  const widgetTitle = getWidgetTitle(blocks[0]) || t('widget.headline');

  return <DefaultContextWidget icon={Icons.INTERNAL_LINK_ARROW} title={widgetTitle} blocks={blocks} {...props} />;
}
